




































import _ from 'lodash';
import { pageFactory } from '@/main/pages/pageFactory';
import { PageMode } from '@/main/utils/pageMode';
import { FILTER, ERROR, editName } from '@/main/store/listEditTypes';

import { NAME, DMS_MODULE, buttons, RozsahDate, SestavaButton, AccessSestavyFlagEnum } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default pageFactory(NAME, store).extend({
	provide() {
		return {
			storeUri: this.storeUri,
		};
	},
	data() {
		return {
			componentName: null,
			buttons,
			selectedButton: null as SestavaButton | null,
			neopravnenText: null as string | null,
		};
	},
	computed: {
		pageMode(): PageMode {
			return PageMode.CREATE;
		},
	},
	async created() {
		try {
			this.selectedButton = _.find(buttons, (btn) => btn.routeName === this.$route.name) ?? null;
			this.neopravnenText = await this.LocalizeChyboveHlasky('neOpravnen');
			this.startLoading();
			await this.$store.dispatch(`${this.storeUri}/${FILTER}`);
			this.initStaticLists();
			const { data } = await apiProvider.getAccessFlag();
			this.accessFlags = data ?? 0;
		} catch (err) {
			this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
		} finally {
			this.endLoading();
		}
	},
	methods: {
				 changeRoute(e:any) {
			 this.$router.push({ name: e.target.value })
    },
		hasPermision(btnPermision: number) {
			return !!(this.accessFlags && btnPermision) || btnPermision === AccessSestavyFlagEnum.NONE;
		},
		initStaticLists() {
			this.AndOrList = [
				{ Text: this.Localize('chkVariaAND'), Value: true },
				{ Text: this.Localize('chkVariaOR'), Value: false },
			];
			this.RozsahDateList = Object.keys(RozsahDate)
				.filter((k) => _.isNaN(Number(k)))
				.map((k) => ({ Text: this.Localize(k), Value: Number(RozsahDate[k as any]) }));
		},
	},
	beforeRouteUpdate(to, from, next) {
		this.selectedButton = _.find(buttons, (btn) => btn.routeName === to.name) ?? null;
		next();
	},
});
